import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { useBanner, useStylesheet } from "../../contexts";
import { extendCommonContentStylesheet } from "@devowl-wp/web-cookie-banner";
const LanguageSwitcher = ()=>{
    const { FooterLanguageSwitcherSelect } = useStylesheet().extend(...extendCommonContentStylesheet);
    const { footerDesign: { languageSwitcher: languageSwitcherChoice }, languageSwitcher, onLanguageSwitch } = useBanner();
    const current = useMemo(()=>languageSwitcher.find((param)=>{
            let { current } = param;
            return current;
        }), [
        languageSwitcher
    ]);
    const hasFlag = languageSwitcherChoice === "flags" && !!(current == null ? void 0 : current.flag);
    return /*#__PURE__*/ _jsxs(FooterLanguageSwitcherSelect, {
        "data-flag": hasFlag,
        children: [
            hasFlag && /*#__PURE__*/ _jsx("span", {
                style: {
                    backgroundImage: `url(${current.flag})`
                }
            }),
            /*#__PURE__*/ _jsx("select", {
                value: current == null ? void 0 : current.locale,
                "aria-label": current == null ? void 0 : current.name,
                onChange: (e)=>{
                    onLanguageSwitch == null ? void 0 : onLanguageSwitch(languageSwitcher.find((param)=>{
                        let { locale } = param;
                        return locale === e.target.value;
                    }));
                },
                children: languageSwitcher.map((param)=>{
                    let { locale, name } = param;
                    return /*#__PURE__*/ _jsx("option", {
                        value: locale,
                        children: name
                    }, locale);
                })
            })
        ]
    });
};
export { LanguageSwitcher };
